import React from 'react';
import {CurrencyInputElement} from 'types/documentTemplateElement';
import {DocumentTemplate} from '../../../types/documentTemplate';
import BaseInputProperties from './BaseInputProperties';

interface CurrencyInputPropertiesProps {
  element: CurrencyInputElement;
  template: DocumentTemplate;
  updateElement: (updatedElement: CurrencyInputElement) => void;
}

const CurrencyInputProperties: React.FC<CurrencyInputPropertiesProps> = ({
  element,
  template,
  updateElement,
}) => {
  return (
    <BaseInputProperties
      element={element}
      template={template}
      updateElement={updateElement}
      hidePlaceholder={true}
    />
  );
};

export default CurrencyInputProperties;
